import React from 'react';

const SoftwareTesting = () => {
  return (
    <div className='skills__content'>
      <h3 className="skills__title">Software Testing</h3>

      <div className="skills__box">
        <div className="skills__group">
            <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                <div>
                    <h3 className="skills__name">Black box testing</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
            </div>

            <div className="skills__data">
                <i className="bx bx-badge-check"></i>

                <div>
                    <h3 className="skills__name">White box testing</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default SoftwareTesting
